import { allPredefinedFilters, filterId } from 'app/area/search-filters/constants';
import { CodetableFeature, CodetableMetadata, CodetableScreenName } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { Filter } from 'app/area/search-filters/filters/types';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { SupportedListScreens } from 'app/area/codetable/list/list-renderer/supported-screens';

export const shouldShowPredefinedFilter = (metadata: CodetableMetadata) => (predefinedFilter: CodeComplexValue<number>): boolean =>
  metadata && predefinedFilter && !!PredefinedFilterAsMetadata[predefinedFilter.value] &&
  !!(metadata[PredefinedFilterAsMetadata[predefinedFilter.value]] ||
    metadata.features[PredefinedFilterAsMetadata[predefinedFilter.value]]);

export const shouldShowFilter = (metadata: CodetableMetadata) => (filter: Filter): boolean =>
  metadata && filter && (shouldShowFilterDueToMetadataFlag(metadata, filter) ||
    shouldShowFilterDueToFormName(metadata, filter) ||
    shouldAlwaysShowFilter(filter));

export const filterCategoryLabel = (codetableId: number, translation: CodetableTranslation, metadata: CodetableMetadata): string => {
  const labels = {
    [SupportedListScreens.InteractionOption]: translation.interaction,
    [SupportedListScreens.ConsequencesSeverity]: translation.consequence_type,
    [SupportedListScreens.ConsequencesRecurrence]: translation.consequence_type,
    [SupportedListScreens.ConsequencesLikelihood]: translation.consequence_type,
    [SupportedListScreens.Reference]: translation.reference_type
  };

  return metadata?.codetableCategory?.label || labels[codetableId] || translation.category;
};

const shouldShowFilterDueToMetadataFlag = (metadata: CodetableMetadata, filter: Filter): boolean =>
  !!FilterAsMetadata[filter.id] &&
  !!(metadata[FilterAsMetadata[filter.id]] ||
    metadata.features[FilterAsMetadata[filter.id]]);

const FilterAsMetadata: { [key: string]: (keyof CodetableMetadata | CodetableFeature) } = {
  [filterId.type]: 'codetableClass',
  [filterId.caseType]: CodetableFeature.caseType,
  [filterId.userGroup]: CodetableFeature.userGroup,
  [filterId.fields]: CodetableFeature.visible
};

const shouldShowFilterDueToFormName = (metadata: CodetableMetadata, filter: Filter): boolean =>
  !!FilterAsFormName[filter.id] && !!FilterAsFormName[filter.id].find(formName => formName === metadata.formName);

const FilterAsFormName: { [key: string]: CodetableScreenName[] } = {
  [filterId.category]: [
    CodetableScreenName.Reference,
    CodetableScreenName.InteractionOption,
    CodetableScreenName.Consequence,
    CodetableScreenName.UnitOfMeasure
  ],
  [filterId.measurementSystem]: [
    CodetableScreenName.UnitOfMeasure
  ]
};

const PredefinedFilterAsMetadata: { [key: string]: (keyof CodetableMetadata | CodetableFeature) } = {
  [allPredefinedFilters.excludeInactiveCodes]: CodetableFeature.disabled
};

const fixedFilters: string[] = [
  filterId.code
];

const shouldAlwaysShowFilter = (filter: Filter): boolean =>
  fixedFilters.includes(filter.id);
